<template>
  <!-- Video card -->
  <el-card class="clip-card box-card">
    <div slot="header" class="videoHeader">
      <el-checkbox
        ref="checkeds"
        v-model="valueCheckbox"
        class="checkbox-wrapper"
        @change="
          $emit('selectedVideoId', { id: info.id, value: valueCheckbox })
        "
      ></el-checkbox>

      <!-- Video information -->
      <video-item-content
        :video-info="info"
        :thumbnail-link="thumbnailLink"
        :snapchat-link="snapchatLink"
        :app="app"
        :hiden-renew-thumbnile="hidenRenewThumbnile"
        :stream="stream"
        :duration="clipDuration"
        :show-button-share="showButtonShare"
        :is-updating-thumbnail="isUpdatingThumbnail"
        :upload-to-mangomolo="
          !info.isUploadedToMangomolo && !isUploadingToMangomolo
        "
        @renewThumbnail="generateThumbnail"
        @openShareModal="isShowSharingModal = true"
        @uploadToMangomolo="uploadToMangomolo"
      />
    </div>
  </el-card>
</template>

<script>
/** Item parts */
import VideoItemContent from "@/components/media/video/VideoItemContent.vue";
/* rest of imports */
import fallbackImage from "@/assets/images/empty.jpg";
import { fitSizesToBorders } from "@/utils/size.js";
import { token } from "@/api/params.js";

import { mapState } from "vuex";

import { MEDIA_CONVERSION_STATUS } from "@/constants.js";

// @group Media/Video
// Video card
export default {
  name: "ModalVideoItem",
  components: {
    VideoItemContent,
  },
  props: {
    clearCheckbox: {
      type: Boolean,
      default: false,
    },
    deleteMarkerCheckbox: {
      type: Boolean,
      default: false,
    },
    // Video clip data
    videoInfo: {
      type: Object,
      required: true,
    },
    // Link to share clip to Snapchat
    snapchatLink: {
      type: String,
      default: null,
    },
    percentCompleted: {
      type: Number,
      default: 0,
    },
    openModalExpress: {
      type: Number,
    },
    mediaItemsList: {
      type: Object,
    },
    mediaTab: {
      type: String,
    },
  },
  data() {
    return {
      arrayItemsList: [],
      hidenRenewThumbnile: true,
      valueCheckbox: false,
      openModalExpressSharing: this.openModalExpress,
      info: this.videoInfo,
      isUploadingToMangomolo: this.isUploadingToMangomolo,
      isShowVideoPreview: false,
      isShowEditForm: false,
      isShowCutForm: false,
      fallbackImage,
      showButtonShare: false,
      playerOptions: {
        autoplay: false,
        controls: true,
        fill: true,
        preload: "none",
        cors: true,
      },
      // isMangomoloUploading: false,
      isUpdatingThumbnail: false,
      isShowSharingModal: false,
      playerWidth: 0,
      playerHeight: 0,
      playerWidthLimit: document.body.offsetWidth > 768 ? 0.5 : 0.8,
      playerHeightLimit: 0.8,
    };
  },
  computed: {
    ...mapState({
      host: (state) => state.services.host,
      app: (state) => state.services.app,
      vod: (state) => state.services.vod,
      stream: (state) => state.services.stream,
      thumbs: (state) => state.services.thumbs,
      sharings: (state) => state.socials.sharings,
    }),
    // @vuese
    // Duration of clip in seconds
    clipDuration() {
      // If metadata not loaded (video is converting), then time is not set
      return this.videoInfo.metadata?.duration;
      // return this.videoInfo.clips.map(e => e.duration);
    },
    videoDistribution() {
      return this.clipDuration < 300
        ? { type: "video/mp4", src: this.downloadLink }
        : {
            type: "application/x-mpegURL",
            src: `${this.host}/clips/_definst_/mp4:${this.info.playLink}?token=${token}`,
          };
    },
    // @vuese
    // Clip width in pixels
    clipWidth() {
      return this.videoInfo.metadata?.width || 1920;
    },
    // @vuese
    // Clip height in pixels
    clipHeight() {
      return this.videoInfo.metadata?.height || 1080;
    },
    // @vuese
    // Link to thumbnail clip image or null (if video not converted)
    thumbnailLink: {
      cache: false,
      get() {
        return this.info.status == MEDIA_CONVERSION_STATUS.READY || this.info.status == MEDIA_CONVERSION_STATUS.REMOTE
          ? `${this.info.thumbnailLink}`
          : fallbackImage;
      },
    },
    // @vuese
    // Download link with storage prefix
    downloadLink() {
      return this.info.status == MEDIA_CONVERSION_STATUS.READY || this.info.status == MEDIA_CONVERSION_STATUS.REMOTE
        ? `${this.videoInfo.downloadLink}`
        : null;
    },
    // @vuese
    // Preview video form title
    previewTitle: {
      cache: false,
      get() {
        return "Video Preview:" + this.videoInfo.title;
      },
    },
    // @vuese
    // Video sharings data
    videoSharings() {
      return this.sharings.filter((s) => s.videoId == this.videoInfo.id);
    },
  },
  watch: {
    clearCheckbox() {
      if (this.clearCheckbox == true) {
        this.valueCheckbox = false;
      }
    },
    // @vuese
    // Update video data
    videoInfo(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.info = newVal;
      }
      if (newVal.isUploadingToMangomolo !== this.isUploadingToMangomolo) {
        this.isUploadingToMangomolo = newVal.isUploadingToMangomolo;
      }
    },
    // @vuese
    // Resize preview video player
    isShowVideoPreview(val) {
      if (val) {
        this.$nextTick(() => {
          // Set preferred width and height for video player
          const maxWidth = document.body.offsetWidth * this.playerWidthLimit;
          const maxHeight = document.body.offsetHeight * this.playerHeightLimit;
          const videoWidth = this.clipWidth;
          const videoHeight = this.clipHeight;
          const widthAddition = -20;
          const heightAddition = widthAddition * (videoHeight / videoWidth);

          const { width: width, height: height } = fitSizesToBorders(
            videoWidth,
            videoHeight,
            maxWidth,
            maxHeight
          );

          this.playerWidth = width + widthAddition;
          this.playerHeight = height + heightAddition;
        });
      }
    },
  },
  methods: {
    changeSelectVideo(info, valueCheckbox) {
      this.arrayItemsList.push(info.id, valueCheckbox);
      this.$emit("arrayItemsList", this.arrayItemsList);
    },
    check(e) {
      this.$nextTick(() => {
        console.log(e.target);
      });
    },
    updateTitle(newTitle) {
      this.info.title = newTitle;
      this.$emit("updateTitleFinish", this.info);
    },
    // @vuese
    // Open clip preview modal
    showVideoPreview() {
      // Stop player when modal opened
      this.$emit("stopPlayer");
      this.$refs.previewVideoPlayer.setSource(
        this.videoDistribution,
        `${this.videoInfo.storageUrl}/${this.info.thumbnailLink}`
      );
      this.isShowVideoPreview = true;
    },
    // @vuese
    // Close clip preview modal
    closeVideoPreview() {
      this.isShowVideoPreview = false;
      this.$refs.previewVideoPlayer.resetSource();
    },
    // @vuese
    // Open edit modal form
    showEditForm() {
      this.$emit("stopPlayer");
      this.isShowEditForm = true;
    },
    // @vuese
    // Open cut modal form
    showCutForm() {
      this.$emit("stopPlayer");
      this.isShowCutForm = true;
    },
    // @vuese
    // Remove clip handler
    async deleteVideo() {
      // User tried to rimove clip
      this.$emit("delete");
    },
    // @vuese
    // Open download clip link in new tab
    downloadClip() {
      this.$emit("download");
    },
    // @vuese
    // Copy download clip link
    clipboardCopy() {
      this.$emit("copy");
    },
    // @vuese
    // Upload clip to Mangomolo service
    uploadToMangomolo() {
      this.isUploadingToMangomolo = true;
      this.$emit("uploadToMangomolo", {
        done: () => {},
      });
    },
    // @vuese
    // Regenerate clip thumbnail
    async generateThumbnail() {
      this.isUpdatingThumbnail = true;
      this.$emit("updatePoster", {
        done: () => {
          this.isUpdatingThumbnail = false;
        },
        success: (link) => {
          this.info.thumbnailLink = link;
        },
      });
    },
    // @vuese
    // Send GIF-generating request
    async generateGIF() {
      this.$emit("gif");
    },
  },
};
</script>

<style>
.checkbox-wrapper {
  margin: 0 auto;
}

@keyframes load-sharing {
  from {
    width: 0px;
  }

  to {
    width: 20px;
  }
}
.share-buttons {
  display: flex;
  justify-content: center;
  align-items: center;
}
.share-buttons a {
  text-decoration: none;
}
.remove-social-sharing-btn {
  cursor: pointer;
}

.watch-modal .modal {
  margin: 0 10px;
}
</style>

<style scoped>
.el-checkbox:last-of-type {
  margin: 66px auto;
}
::-webkit-input-placeholder {
  /* Chrome/Opera/Safari */
  color: #aaa;
}
::-moz-placeholder {
  /* Firefox 19+ */
  color: #aaa;
}
:-ms-input-placeholder {
  /* IE 10+ */
  color: #aaa;
}
:-moz-placeholder {
  /* Firefox 18- */
  color: #aaa;
}

.box-card {
  margin-bottom: 15px;
  overflow: hidden;
  background-color: #aaaaaa;
  justify-self: center;
}
.videoHeader {
  display: flex;
  justify-content: space-between;
  text-align: center;
  padding: 12px;
}

.el-card__header {
  padding: 10px !important;
}

.el-card__body {
  padding: 10px !important;
}
@media only screen and (max-width: 639px), only screen and (max-height: 740px) {
  .box-card {
    width: 357px;
  }
  .el-checkbox {
    margin: 143px auto !important;
  }
}
</style>
